module.exports = __webpack_public_path__ + "static/img/header-car.7ebab45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header-car.png
// module id = 5yXK
// module chunks = 3